import { localDelete, localGet, localPut } from 'utils/storage/local-storage';
import { DBStore, DBStoreParams, DBStoreTypes, UpsertParams } from 'utils/storage/types';

export interface AgentDBValue {
  key: string;
  firstName: string;
  avatarUrl: string;
}

const Agent: DBStore<AgentDBValue | string> = {
  upsert({ key, data, discriminator }: UpsertParams<AgentDBValue | string>) {
    return new Promise(resolve => {
      if (key && typeof data === 'string') {
        const value = localGet<AgentDBValue>({ key: DBStoreTypes.AGENT, discriminator });
        localPut<AgentDBValue>({
          key: DBStoreTypes.AGENT,
          data: Object.assign({}, value, { [key]: data }),
          discriminator,
        });
      } else {
        localPut<AgentDBValue>({
          key: DBStoreTypes.AGENT,
          data: data as AgentDBValue,
          discriminator,
        });
      }
      resolve();
    });
  },

  get({ key, discriminator }: DBStoreParams) {
    return new Promise(resolve => {
      const value = localGet<AgentDBValue>({ key: DBStoreTypes.AGENT, discriminator });
      if (value && key) {
        resolve(value[key] as string);
      } else {
        resolve(value as AgentDBValue);
      }
    });
  },

  delete({ key, discriminator }: DBStoreParams) {
    return new Promise((resolve, reject) => {
      if (key) {
        const data = localGet<AgentDBValue>({ key: DBStoreTypes.AGENT, discriminator });
        if (data) {
          const result = delete data[key];
          if (!result) {
            reject(
              new Error(`Could not delete key [${key}] as it is non-existent. No changes made.`)
            );
          } else {
            localPut<AgentDBValue>({ key: DBStoreTypes.AGENT, data, discriminator });
            resolve();
          }
        }
      } else {
        localDelete({ key: DBStoreTypes.AGENT, discriminator });
        resolve();
      }
    });
  },
};

export default Agent;
